import React from 'react';

class ErrorBoundaryDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('PhlebDetail crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="detail-panel open">
          <div className="detail-header">
            <button className="back-btn" onClick={() => this.props.onBack()}>← Back</button>
            <div style={{ fontSize: 14, color: 'var(--bodygray)' }}>Something went wrong</div>
          </div>
          <div style={{ padding: '24px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>
              Unable to load this stop
            </div>
            <div style={{ fontSize: 12, color: 'var(--bodygray)', marginBottom: 20 }}>
              Please go back and try again. If the problem continues let your supervisor know.
            </div>
            <button
              onClick={() => this.props.onBack()}
              style={{
                padding: '10px 24px', borderRadius: 10, border: 'none',
                background: 'var(--rp)', color: 'white',
                fontFamily: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              }}
            >
              ← Back to My Stops
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundaryDetail;